import { gql } from '@apollo/client';

export const ADD_UPDATE_DOCUMENT_TYPE_PROPERTY = gql`
  mutation addOrUpdateDocumentTypeProperty($input: DocumentTypePropertyItemInput) {
    addOrUpdateDocumentTypeProperty(input: $input) {
      commandId
    }
  }
`;

export const ADD_UPDATE_DOCUMENT_TYPE_PROPERTY_X_STATE = gql`
  mutation addOrUpdateDocumentTypePropertyXState($input: DocumentTypePropertyXStateItemInput) {
    addOrUpdateDocumentTypePropertyXState(input: $input) {
      commandId
    }
  }
`;
